import { render, staticRenderFns } from "./JenisPembayaran.vue?vue&type=template&id=2755bc67&scoped=true"
import script from "./JenisPembayaran.vue?vue&type=script&lang=js"
export * from "./JenisPembayaran.vue?vue&type=script&lang=js"
import style0 from "./JenisPembayaran.vue?vue&type=style&index=0&id=2755bc67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2755bc67",
  null
  
)

export default component.exports